<!-- Full Modal View -->
<div class="video-modal-container music-player-modal-container">
  <div class="video-modal-overlay"></div>
  <div
    class="video-modal-wrapper"
    [ngClass]="{
      'podcast-modal-wrapper': portfolioType === PORTFOLIO_CONSTS.TYPE.PODCAST
    }"
  >
    <div class="video-modal-content">
      <div
        class="music-player-wrapper"
        [class.music-locked]="isLocked"
        [ngClass]="{
          'podcast-wrapper': portfolioType === PORTFOLIO_CONSTS.TYPE.PODCAST
        }"
      >
        <div class="album-title-share" [ngClass]="{
          'album-title-share-podcast': portfolioType === PORTFOLIO_CONSTS.TYPE.PODCAST
        }">
          <div class="share-button-container">
            <button class="share-button" (click)="onShareClick()" aria-label="Share">
              <em class="icon-profile-share"></em>
            </button>
          </div>
            <div class="title-description-container">
              <span class="title" *ngIf="currentMusic?.albumTitle">
                {{ currentMusic?.albumTitle }}
              </span>
              <span class="description" *ngIf="currentMusic?.songTitle">
                {{ currentMusic?.songTitle }}
              </span>
              <span class="date-of-release" *ngIf="currentMusic?.dateOfRelease">
                {{
                  isReleaseYearType
                    ? MUSIC_PLAYER_CONST.RELEASED_YEAR
                    : MUSIC_PLAYER_CONST.RELEASED
                }}: {{ currentMusic?.dateOfRelease }}
              </span>
    
              <p
                *ngIf="
                  currentMusic?.description &&
                  portfolioType === PORTFOLIO_CONSTS.TYPE.PODCAST
                "
                class="description-text"
                [innerHTML]="
                  currentMusic
                    | contentLengthHandler: descriptionMaxLength : 3
                    | bioFormat
                "
                (click)="$event.stopPropagation(); seeLessMore()"
              ></p>
            </div>
        </div>
        <div class="preview-image-container">
          <div
            class="audio-loader-overlay"
            *ngIf="isLoadingAudio && (!isLocked || currentMusic?.canPreview)"
          >
            <app-loader></app-loader>
          </div>
          <img
            (click)="onAudioClick($event)"
            *ngIf="currentMusic?.previewImageUrl"
            [src]="currentMusic?.previewImageUrl"
            alt="Preview Image"
            class="preview-image"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="currentMusic?.previewImageUrl"
            [format]="'webp'"
            loading="lazy"
            decoding="async"
          />
          <div
            class="skeleton-thumbnail preview-image"
            *ngIf="!currentMusic?.previewImageUrl"
          >
            <div class="song-audio-icon">
              <em class="icon-litemusic-node-2"></em>
            </div>
          </div>
          <!-- Locked Content Overlay -->
          <div class="black-overlay" *ngIf="showLockedContent"></div>

          <!-- Payment Options -->
          <div
            class="d-flex flex-column subscription-option"
            *ngIf="showLockedContent && lockedThrough"
          >
            <div class="locked-system">
              <div class="d-flex flex-column buttons">
                <app-button
                  *ngIf="lockedThrough?.individual?.individual_price"
                  (click)="purchaseIndividualMusic()"
                  [btnField]="{
                    type: 'button',
                    label: individualPurchaseText,
                    class: 'btn btn-primary w-100',
                    disabled:
                      currentMusic?.unlocked_through?.hasOwnProperty(
                        'is_outer_unlocked'
                      ) && !currentMusic?.unlocked_through?.is_outer_unlocked
                  }"
                ></app-button>

                <div *ngIf="showOrBeforeSubscription" class="or-text">
                  {{ MUSIC_PLAYER_CONST.OR }}
                </div>

                <app-button
                  *ngIf="lockedThrough?.subscription?.length"
                  (click)="purchaseSubscription()"
                  [btnField]="{
                    type: 'button',
                    label: PURCHASE_TEXT_MAP[portfolioType].SINGLE.SUBSCRIPTION,
                    class: 'btn btn-primary w-100',
                    disabled:
                      currentMusic?.unlocked_through?.hasOwnProperty(
                        'is_outer_unlocked'
                      ) && !currentMusic?.unlocked_through?.is_outer_unlocked
                  }"
                ></app-button>

                <div *ngIf="showOrBeforeNft" class="or-text">
                  {{ MUSIC_PLAYER_CONST.OR }}
                </div>

                <app-button
                  *ngIf="lockedThrough?.nft?.length"
                  (click)="purchaseNftMusic()"
                  [btnField]="{
                    type: 'button',
                    label: PURCHASE_TEXT_MAP[portfolioType].SINGLE.NFT,
                    class: 'btn btn-primary w-100',
                    disabled:
                      currentMusic?.unlocked_through?.hasOwnProperty(
                        'is_outer_unlocked'
                      ) && !currentMusic?.unlocked_through?.is_outer_unlocked
                  }"
                ></app-button>

                <div *ngIf="showOrBeforeLoyaltyInline" class="or-text">
                  {{ MUSIC_PLAYER_CONST.OR }}
                </div>
                <button
                  *ngIf="
                    !!lockedThrough?.individual?.loyalty_points &&
                    authService?.isWhiteLabelWebsite()
                  "
                  type="button"
                  (click)="openUnlockCurrentMusicWithPoints()"
                  class="btn btn-primary medium unlock-with-points-btn w-100"
                  [disabled]="
                    currentMusic?.unlocked_through?.hasOwnProperty(
                      'is_outer_unlocked'
                    ) && !currentMusic?.unlocked_through?.is_outer_unlocked
                  "
                >
                  <span class="unlock-with-points-btn__label">{{
                    LOCKED_POST_MESSAGES.UNLOCK_POST_LOYALTY_PREFIX
                  }}</span>
                  <img
                    class="unlock-with-points-btn__coin"
                    src="assets/images/svg/feature-icons/point-coin.svg"
                    width="24"
                    height="24"
                    [attr.alt]="LOYALTY_POINTS_TEXT.COIN_ALT"
                    loading="lazy"
                    decoding="async"
                  />
                  <span class="unlock-with-points-btn__points">
                    {{ lockedThrough?.individual?.loyalty_points | number }}
                    {{ LOYALTY_POINTS_AMOUNT_SUFFIX }}
                  </span>
                </button>

                <div
                  *ngIf="
                    masterData?.isLocked &&
                    (masterData?.lock_through?.individual?.individual_price ||
                      masterData?.lock_through?.subscription?.length ||
                      masterData?.lock_through?.nft?.length)
                  "
                  class="or-text"
                >
                  {{ MUSIC_PLAYER_CONST.OR }}
                </div>
                <app-button
                  *ngIf="
                    masterData?.isLocked &&
                    (masterData?.lock_through?.individual?.individual_price ||
                      masterData?.lock_through?.subscription?.length ||
                      masterData?.lock_through?.nft?.length)
                  "
                  (click)="purchaseMasterData()"
                  [btnField]="{
                    type: 'button',
                    label: PURCHASE_MASTER_DATA_TEXT[portfolioType],
                    class: 'btn btn-primary w-100'
                  }"
                ></app-button>
              </div>

              <div class="purchase-via-subscription-lock">
                <app-unlock-content
                  *ngIf="currentMusic"
                  class="unlock-content merchandise"
                  #shopifyUnlocker
                  [contentId]="currentMusic?.sk"
                  [lockDetails]="currentMusic"
                  [userProfile]="userProfile"
                  [userSubscriptionList]="userSubscriptionList"
                  [contentType]="paymentForType.MUSIC_PORTFOLIO"
                  [headerType]="PORTFOLIO_TITLE_HEADING_MAP[portfolioType]"
                  [userId]="userProfile?.email"
                  [isLocked]="
                    !currentMusic?.unlocked_through?.is_outer_unlocked
                  "
                ></app-unlock-content>
              </div>
            </div>
          </div>
        </div>
        <audio
          #audioPlayer
          class="audio-player"
          [src]="currentMusic?.audioUrl"
          (loadedmetadata)="onAudioLoadedMetadata()"
          (loadstart)="onAudioLoadStart()"
          (error)="onAudioError()"
          (timeupdate)="onAudioTimeUpdate()"
          (play)="onAudioPlay()"
          (pause)="onAudioPause()"
          (ended)="onAudioEnded()"
          (volumechange)="onAudioVolumeChange()"
          (ratechange)="onAudioRateChange()"
          *ngIf="!isLocked || currentMusic?.canPreview"
        ></audio>
      </div>

      <div
        class="video-controls"
        [class.controls-disabled]="isLocked && !currentMusic?.canPreview"
      >
        <div class="control-group-center">
          <button
            class="control-btn"
            (click)="playPreviousMusic()"
            [style.color]="buttonColor"
            [disabled]="!hasPreviousMusic()"
            [class.disabled]="!hasPreviousMusic()"
            [attr.aria-label]="'Previous music'"
          >
            <em class="icon-liteGroup"></em>
          </button>
          <button
            class="control-btn rewind-15"
            (click)="rewind()"
            [style.color]="buttonColor"
            [disabled]="isLocked && !currentMusic?.canPreview"
          >
            <em class="icon-litebackward-15"></em>
          </button>
          <button
            class="control-btn play-pause-btn"
            (click)="togglePlayPause()"
            [disabled]="isLocked && !currentMusic?.canPreview"
          >
            <span *ngIf="!isPlaying" class="play-icon">
              <em class="icon-liteplay"></em>
            </span>
            <span *ngIf="isPlaying" class="pause-icon">
              <em class="icon-litepause"></em>
            </span>
          </button>
          <button
            class="control-btn forward-15"
            (click)="fastForward()"
            [style.color]="buttonColor"
            [disabled]="isLocked && !currentMusic?.canPreview"
          >
            <em class="icon-liteforward-15"></em>
          </button>
          <button
            class="control-btn"
            (click)="playNextMusic()"
            [style.color]="buttonColor"
            [disabled]="!hasNextMusic()"
            [class.disabled]="!hasNextMusic()"
            [attr.aria-label]="'Next music'"
          >
            <em class="icon-liteGroup1"></em>
          </button>
        </div>

        <div class="controls-row">
          <div class="time-display-left">
            <span>{{ formatTime(currentTime) }}</span>
          </div>

          <div
            class="progress-bar-container"
            (click)="seek($event)"
            [class.disabled]="isLocked"
          >
            <div
              class="progress-bar"
              [style.background-color]="progressBarColor"
              [style.width.%]="getProgressPercent()"
            ></div>
            <div
              class="progress-indicator"
              [style.left.%]="getProgressPercent()"
              [style.background-color]="progressBarColor"
            ></div>
          </div>

          <div class="control-group-right">
            <span class="time-display-right">{{ formatTime(duration) }}</span>

            <div class="speed-control" *ngIf="cs.isBrowser">
              <button
                class="control-btn speed-btn"
                (click)="toggleSpeedMenu()"
                [style.color]="buttonColor"
              >
                <span class="speed-rate">{{ playbackRate }}x</span>
                <em class="icon-litechevron_down"></em>
              </button>
              <div class="speed-menu" *ngIf="showSpeedMenu">
                <button
                  *ngFor="let rate of playbackRates"
                  class="speed-option"
                  [class.active]="rate === playbackRate"
                  (click)="setPlaybackRate(rate)"
                >
                  {{ rate }}x
                </button>
              </div>
            </div>

            <button
              *ngIf="currentMusic?.isDownloadable"
              class="control-btn"
              (click)="downloadVideo()"
              [style.color]="buttonColor"
              [disabled]="isLocked"
            >
              <em class="icon-litedownload"></em>
            </button>

            <div class="volume-control" *ngIf="!isMobile">
              <button
                class="control-btn volume-btn"
                (click)="toggleVolumeSlider()"
                (contextmenu)="toggleMute(); $event.preventDefault()"
                [style.color]="buttonColor"
              >
                <em
                  *ngIf="!isMuted && volume > Application.ZERO"
                  class="icon-liteic-volume"
                ></em>
                <em
                  *ngIf="isMuted || volume === Application.ZERO"
                  class="icon-litespeaker-mute"
                ></em>
              </button>
              <div class="volume-slider-container" *ngIf="showVolumeSlider">
                <input
                  type="range"
                  class="volume-slider"
                  [min]="Application.ZERO"
                  [max]="Application.ONE"
                  step="0.01"
                  [value]="volume"
                  (input)="onVolumeChange($event)"
                  (click)="$event.stopPropagation()"
                />
              </div>
            </div>

            <button
              *ngIf="allowMinimizePlayer && authService.isLogin"
              class="control-btn"
              (click)="minimizeModal()"
            >
              <em class="icon-liteshrink"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
    <button
      class="close-button"
      (click)="closeModal()"
      [style.color]="closeButtonColor"
    >
      <span>✕</span>
    </button>
  </div>
</div>

<app-portfolio-unlock-modal
  #unlockModal
  [selectedItem]="selectedItem"
  [userProfile]="userProfile"
  [userSubscriptionList]="userSubscriptionList"
  [contentType]="paymentForType.MUSIC_PORTFOLIO"
  [headerType]="PORTFOLIO_TITLE_HEADING_MAP[portfolioType]"
  [userId]="userProfile?.email"
  [userName]="portfolioCreatorUserName || userProfile?.user_name || ''"
  [portfolioTypeId]="
    portfolioTypeId ||
    (masterData?.sk ? cs.decodeToUTF(masterData.sk) : '')
  "
  [isIndividualPortfolio]="isIndividualPortfolio"
  [isLocked]="selectedItem?.isLocked"
  [portfolioType]="portfolioType"
  [isAlbumLocking]="
    selectedItem?.sk &&
    masterData?.sk &&
    selectedItem?.sk === masterData?.sk
  "
  [unlockModalHeader]="unlockModalHeader"
  [isAllowedToRedirect]="false"
  [onLoyaltyPointsPurchaseNavigate]="closePlayerModalForLoyaltyPaymentRedirect.bind(this)"
  (purchaseIndividual)="onPurchaseMasterIndividual()"
  (purchaseSubscription)="onPurchaseMasterSubscription()"
  (purchaseNft)="onPurchaseMasterNft()"
  (unlockedWithPoints)="onPortfolioUnlockedWithPoints()"
></app-portfolio-unlock-modal>
